import {Injectable} from '@angular/core';
import {TranslateLoader, TranslationObject} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable()
export class DAMTranslationLoader implements TranslateLoader{
    constructor(private http: HttpClient) { }

    getTranslation(lang: string): Observable<TranslationObject> {
        const url = `${environment.apiUrl}translations/${lang}`;

        // @ts-ignore
        return this.http.get<TranslationObject>(url + '.json?header=false')
            .pipe(map((res: Object) => this.process(res)));
    }
    private process(object: any) {
        const newObject = {};

        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                if (typeof object[key] === 'object') {
                    // @ts-ignore
                    newObject[key] = this.process(object[key]);
                }
                else if ((typeof object[key] === 'string') && (object[key] === '')) {
                    // do not copy empty strings
                }
                else {
                    // @ts-ignore
                    newObject[key] = object[key];
                }
            }
        }

        return newObject;
    }

}
